<template>
  <div class="loading">
    <transition name="fade">
      <v-progress-linear
        v-if="visible"
        color="warning"
        height="3"
        indeterminate
      />
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  display: flex;
  flex-direction: row;
  position: relative;
  width: 100%;

  .v-progress-linear {
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 1;
  }
}
</style>
